module.exports = __webpack_public_path__ + "img/commercial-banner.7145c501.png";